import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ByzMuiTypography from '../../../components/core-components/mui/inputs/ByzMuiTypography';
import ByzMuiButton from '../../../components/core-components/mui/buttons/ByzMuiButton';
import { useTranslate } from 'src/locales';

type Props = {
    open: boolean;
    onClose: VoidFunction;
    onConfirm: VoidFunction;
};

export default function AccountLogoutDialog({ open, onClose, onConfirm }: Props) {
    const { t } = useTranslate();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>
                {t('profile-menu-items.logout')}
            </DialogTitle>
            <DialogContent sx={{ pb: 3 }}>
                <ByzMuiTypography variant="body1">
                    {t('logout-confirm-message')}
                </ByzMuiTypography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <ByzMuiButton
                    onClick={onClose}
                    variant2="outlined"
                    color="inherit"
                    sx={{ px: 3 }}
                >
                    {t('buttons.cancel')}
                </ByzMuiButton>
                <ByzMuiButton
                    onClick={onConfirm}
                    color="primary"
                    variant2="outlined"
                    sx={{ px: 3 }}
                >
                    {t('login.logout')}
                </ByzMuiButton>
            </DialogActions>
        </Dialog>
    );
}
